module.exports = __webpack_public_path__ + "img/circle.1c123a38.png";